module.exports = __webpack_public_path__ + "img/lb8_h5.15456552.png";